import { openBlock as a, createElementBlock as l, normalizeClass as n, renderSlot as m, createCommentVNode as p, createElementVNode as u, Fragment as h, renderList as f } from "vue";
const v = { name: "content-placeholders", computed: { classObject() {
  return { "vue3-content-placeholders": !0, "vue3-content-placeholders-is-rounded": this.rounded, "vue3-content-placeholders-is-centered": this.centered, "vue3-content-placeholders-is-animated": this.animated };
} }, props: { rounded: { type: Boolean, default: !1 }, centered: { type: Boolean, default: !1 }, animated: { type: Boolean, default: !0 } } };
const d = (t, o) => {
  const s = t.__vccOpts || t;
  for (const [c, e] of o)
    s[c] = e;
  return s;
};
function N(t, o, s, c, e, r) {
  return a(), l("div", { class: n(r.classObject) }, [m(t.$slots, "default")], 2);
}
const g = d(v, [["render", N]]), _ = { name: "content-placeholders-heading", data() {
  return { className: "vue3-content-placeholders-heading" };
}, props: { img: { type: Boolean, default: !1 } } };
function C(t, o, s, c, e, r) {
  return a(), l("div", { class: n(e.className) }, [s.img ? (a(), l("div", { key: 0, class: n(`${e.className}__img`) }, null, 2)) : p("", !0), u("div", { class: n(`${e.className}__content`) }, [u("div", { class: n(`${e.className}__title`) }, null, 2), u("div", { class: n(`${e.className}__subtitle`) }, null, 2)], 2)], 2);
}
const y = d(_, [["render", C]]), P = { name: "content-placeholders-img", data() {
  return { className: "vue3-content-placeholders-img" };
} };
function $(t, o, s, c, e, r) {
  return a(), l("div", { class: n(e.className) }, null, 2);
}
const B = d(P, [["render", $]]), b = { name: "content-placeholders-text", data() {
  return { className: "vue3-content-placeholders-text" };
}, props: { lines: { type: Number, default: 4 } } };
function x(t, o, s, c, e, r) {
  return a(), l("div", { class: n(e.className) }, [(a(!0), l(h, null, f(s.lines, (i) => (a(), l("div", { key: i, class: n(`${e.className}__line`) }, null, 2))), 128))], 2);
}
const k = d(b, [["render", x]]), j = { install: (t) => {
  t.component("ContentPlaceholders", g), t.component("ContentPlaceholdersHeading", y), t.component("ContentPlaceholdersImg", B), t.component("ContentPlaceholdersText", k);
} };
export {
  g as ContentPlaceholders,
  y as ContentPlaceholdersHeading,
  B as ContentPlaceholdersImg,
  k as ContentPlaceholdersText,
  j as default
};
